import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
// actions
import { updateHeader, getReturnLabelStatus } from '../../../../actionCreators/returnExchange';
import { setToastMessage } from '../../../../actionCreators/common';
// helpers
import { showElement } from '../../../../utils/helper';
import { setWindowDtm } from '../../../../utils/DTM';
// styles
import './ReturnLabel.scss';

class ReturnLabel extends PureComponent {
  constructor(props) {
    super(props);
    const { updateHeader, match } = this.props;
    this.returnId = match.params.returnId;
    updateHeader();
    this.downloadReturnLabel = this.downloadReturnLabel.bind(this);
    this.triggerDtmOnClick = this.triggerDtmOnClick.bind(this);
  }

  componentDidMount() {
    showElement('#app-footer', false);
    this.triggerDtmOnLoad();
  }

  componentDidUpdate(prevProps) {
    const {
      returnLabelGenerated,
      returnConfig,
      setToastMessage,
      dataLocale: { TECHNICAL_ERROR },
    } = this.props;
    if (prevProps.returnLabelGenerated !== returnLabelGenerated && returnLabelGenerated !== null) {
      if (returnLabelGenerated) {
        const { downloadLink } = (returnConfig && returnConfig.returnLabel) || {};
        window.location.href = `${downloadLink}/RL${this.returnId}.pdf`;
      } else {
        setToastMessage({ message: TECHNICAL_ERROR, timeout: 5000 });
      }
    }
  }

  componentWillUnmount() {
    showElement('#app-footer', true);
  }

  downloadReturnLabel() {
    const { getReturnLabelStatus } = this.props;
    if (this.returnId) {
      getReturnLabelStatus(this.returnId);
    }
    this.triggerDtmOnClick('SHARE OR DOWNLOAD');
  }

  triggerDtmOnClick(cta) {
    const { orderDetails } = this.props;
    const orderId = orderDetails && orderDetails.id;
    const dtm = {
      linkName: `web|my account|return or exchange|return label|${cta}`,
      linkPageName: 'web|my account|return or exchange|return label',
      productID: this.dtmProductIds || '',
      brand: this.dtmBrandNames || '',
      category: this.dtmCategories || '',
      price: this.dtmPrices || '',
      returnOrderID: orderId,
      pageType: 'return flow',
      returnMethod: 'warehouse_return',
      event: 'account',
    };
    setWindowDtm(dtm);
  }

  triggerDtmOnLoad() {
    const { orderDetails, returnProducts } = this.props;
    const orderId = orderDetails && orderDetails.id;
    if (!orderId || !(returnProducts && returnProducts.length)) return;
    this.dtmProductIds = [];
    this.dtmBrandNames = [];
    this.dtmCategories = [];
    this.dtmPrices = [];
    for (let i = 0, len = returnProducts.length; i < len; i += 1) {
      const item = returnProducts[i];
      const { productId, brandName, productTypeValue, amount } = item;
      this.dtmProductIds.push(productId);
      this.dtmBrandNames.push(brandName);
      this.dtmCategories.push(productTypeValue);
      this.dtmPrices.push(amount.total);
    }
    this.dtmProductIds = this.dtmProductIds.join('|');
    this.dtmBrandNames = this.dtmBrandNames.join('|');
    this.dtmCategories = this.dtmCategories.join('|');
    this.dtmPrices = this.dtmPrices.join('|');
    const dtm = {
      pageName: 'web|my account|return exchange|return label',
      channel: 'web|my account',
      subSection1: 'web|my account|return or exchange',
      subSection2: 'web|my account|return or exchange|return label',
      productID: this.dtmProductIds,
      brand: this.dtmBrandNames,
      category: this.dtmCategories,
      price: this.dtmPrices,
      returnOrderID: orderId,
      pageType: 'return flow',
      returnMethod: 'warehouse_return',
      event: 'account',
    };
    setWindowDtm(dtm);
  }

  render() {
    const { returnConfig, dataLocale } = this.props;
    const returnLabel = returnConfig && returnConfig.returnLabel;
    const { INSTRUCTIONS_FOR_RETURN_LABEL, SHARE_OR_DOWNLOAD_LABEL, IC, SAMPLE_LABLE, SAMPLE } =
      dataLocale;
    return (
      <div className="bg-pale_grey pd-t10">
        <div className="returnlabel bg-color_white pd-15">
          <div className="mr-b15 fw600 roboto fsp14 fs17 lh-16 text-color_grey_black">
            {INSTRUCTIONS_FOR_RETURN_LABEL}
          </div>
          <div className="margin-t10 margin">
            {returnLabel &&
              returnLabel.info &&
              returnLabel.info.map((infoItem, index) => {
                return (
                  <div key={index} className="display-flex fs15 mr-b12">
                    <div className="info-icon mr-t4">
                      <img
                        alt={IC}
                        src="https://static.lenskart.com/media/mobile/universal/images/returnExchange/Arrow.svg"
                      />
                    </div>
                    <div className="info-text fsp14 lh-20 text-color_dull_black">
                      {infoItem.text}
                    </div>
                  </div>
                );
              })}
            <div
              className="download padding-5 margin-b14 margin-t23 new-btn pd-8 pd-b8 fsp14 fw500 bg-topaz mr-l30 text-center margin-t23 text-color_white_smoke"
              style={{ margin: 'auto', width: '220px', marginTop: '23px' }}
              onClick={this.downloadReturnLabel}
            >
              <span className="text-color_white">
                {(returnLabel && returnLabel.buttonText) || SHARE_OR_DOWNLOAD_LABEL}
              </span>
            </div>
          </div>
          <div className="mr-t20 mr-l30">
            <div className="text-color_pale_black text-color-grey margin-b6 text-center margin-t10">
              <em>{SAMPLE_LABLE}</em>
            </div>
            <div className="mr-t10 display-flex align-items-center justify-content-center">
              <img alt={SAMPLE} src={returnLabel.sampleImg} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  returnConfig: state.myAccount.returnConfig,
  orderDetails: state.order.orderDetails && state.order.orderDetails.result,
  returnProducts: state.returnExchange.returnProducts,
  returnLabelGenerated: state.returnExchange.returnLabelGenerated,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    updateHeader: () => dispatch(updateHeader('RETURN LABEL')),
    getReturnLabelStatus: groupId => dispatch(getReturnLabelStatus(groupId)),
    setToastMessage: data => dispatch(setToastMessage(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnLabel);
